module.exports = __webpack_public_path__ + "img/swiper1Img.db3e5f6f.png";